import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsCheck2Square, BsSlashCircle } from "react-icons/bs";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { FcMoneyTransfer, FcServiceMark } from "react-icons/fc";
import { useSelector } from "react-redux";

const ViewScrumMeeting = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [dataHistory, setDataHistory] = useState();
  const [refresh, setRefresh] = useState(false);
  const [empData, setEmpData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();
  const [leadOwner, setLeadOwner] = useState();
  const store = useSelector((store) => store.login.user);

  const duplicateRequest = () => {
    navigate(`/conduct-new-scrum/?duplicate=${id}`);
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/scrumMeeting/scrumMeetingById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/employeeManagement/getEmployeeById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setEmpData(res?.data);
        } else {
          Toast("error", "Error while getting Employee!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const getEmployeeName = (id) => {
    // If ID not exists
    if (!id) return <div>No Employee Selected</div>;

    // Manually search from your leadOwner array (faster + no API needed)
    const emp = leadOwner?.find((e) => Number(e.id) === Number(id));

    if (!emp) return <div>Employee Not Found</div>;

    return (
      <div className="p-2 border rounded bg-light mt-2">
        <strong style={{ color: "black", fontSize: "15px" }}>Name:</strong>{" "}
        <span style={{ color: "black", fontSize: "15px" }}>{emp.userName}</span>
      </div>
    );
  };

  const returnClassname = (isApproved) => {
    return isApproved
      ? "badge bg-success  text-white"
      : "badge bg-danger  text-white";
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcServiceMark />
                  Scrum Meeting
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Scrum Meeting</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Meeting Title :
                  </label>
                  <div className="w-100 col">
                    {(data?.title || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Date:</label>
                  <div className="w-100 col">
                    {(data?.date || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && data?.conductMetting && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Conduct Metting:
                  </label>
                  <div className="w-100 col">
                    {(data?.conductMetting || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && data?.depName && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Department Name:
                  </label>
                  <div className="w-100 col">
                    {(data?.depName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && data?.demoUpdates && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Demo Updates:</label>
                  <div className="w-100 col">
                    <ul>
                      {(data?.demoUpdates || "N/A")
                        .trim()
                        .toLowerCase()
                        .split("\n")
                        .filter((line) => line.trim() !== "")
                        .map((line, index) => {
                          const sentenceCase =
                          line.trim().charAt(0).toUpperCase() + line.trim().slice(1);
                    
                        return <li key={index}>{sentenceCase}</li>})}
                    </ul>
                  </div>
                </div>
              )}

              {data?.lineItems?.length > 0 && (
                <>
                  <hr className="mb-4" />
                  <h2>Employee Updates</h2>
                  <hr className="mb-0" />
                  <div className="row mt-3">
                    {data.lineItems.map(
                      (lineItem, index) =>
                        (store?.UserId == lineItem?.eid ||
                          store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                          store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                          store.Role === process.env.REACT_APP_ROLE_HR ||
                          store.Role === process.env.REACT_APP_ROLE_JR_HR) && (
                          <div className="col-md-4 mb-3" key={index}>
                            <div
                              className={`card shadow-sm h-100 border-0 ${
                                lineItem.present
                                  ? "bg-green-lt text-black"
                                  : "bg-red-lt text-black"
                              }`}
                              style={{ borderRadius: "12px" }}
                            >
                              <div className="card-body">
                                {/* Employee Name */}
                                <h5
                                  className="ms-2 badge bg-primary"
                                  style={{ color: "white" }}
                                >
                                  {lineItem?.empDate}
                                </h5>
                                <h5 className="card-title text-primary fw-bold mb-1">
                                  <div key={index}>
                                    {getEmployeeName(lineItem?.eid)}
                                  </div>
                                </h5>
                                <hr className="mt-1 mb-1 p-0"></hr>

                                {/* Scrum Update */}
                                <p className="card-text mb-2">
                                  <strong
                                    style={{ color: "black" }}
                                    className="ps-2"
                                  >
                                    Employee Update :
                                  </strong>{" "}
                                  <br></br>
                                  <hr className="mt-1 mb-1 p-0"></hr>
                                  <div
                                    key={index}
                                    className="fw-bold mb-1 card p-3"
                                  >
                                    {/* {lineItem?.scrumUpdate || "N/A"} */}
                                    <ul>
                                      {(lineItem?.scrumUpdate || "N/A")
                                        .trim()
                                        .toLowerCase()
                                        .split("\n")
                                        .filter((line) => line.trim() !== "")
                                        .map((line, index) => {
                                          const sentenceCase =
                                          line.trim().charAt(0).toUpperCase() + line.trim().slice(1);
                                    
                                        return <li key={index}>{sentenceCase}</li>})}
                                    </ul>
                                  </div>
                                </p>
                                <hr className="mt-1 mb-1 p-0"></hr>
                                {/* Present / Absent */}
                                {lineItem?.absent && (
                                  <span className="badge px-3 py-2">
                                    ABSENT
                                  </span>
                                )}
                                {lineItem?.present && (
                                  <span className="badge px-3 py-2">
                                    PRESENT
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        )
                    )}
                  </div>
                </>
              )}

              <div className="card-footer">
                <div className="btn-list justify-content-end">
                  {store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                  store.Role === process.env.REACT_APP_ROLE_HR ||
                  store.Role === process.env.REACT_APP_ROLE_JR_HR ||
                  store.Role === process.env.REACT_APP_ROLE_IT ? (
                    <button
                      disabled={data?.status}
                      onClick={() => {
                        navigate(`/conduct-scrum-edit/${id}`);
                      }}
                      className="btn mx-1 mt-2 btn-primary"
                    >
                      {" "}
                      <BsCheck2Square className="fs-2 me-2" />
                      {`EDIT  ${
                        data?.conductMetting === "Demo" ? "DEMO" : "SCRUM"
                      } MEETING DETAILS`}
                    </button>
                  ) : (
                    ""
                  )}
                  {store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                  store.Role === process.env.REACT_APP_ROLE_HR ||
                  store.Role === process.env.REACT_APP_ROLE_JR_HR ? (
                    <SimpleButton
                      buttonText="Duplicate"
                      onClick={duplicateRequest}
                    />
                  ) : (
                    ""
                  )}

                  <SimpleButton buttonText="Cancel" type="secondary" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewScrumMeeting;
